import AdminPageScreen from "features/Admin";

const AdminPage = () => {
  return <AdminPageScreen />;
};

export default AdminPage;
